import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { Bind } from 'primeng/bind';
import { Tabs, TabPanels, TabPanel } from 'primeng/tabs';

@Component({
    selector: 'app-united-insurance-home',
    templateUrl: './united-insurance-home.component.html',
    styleUrls: ['./united-insurance-home.component.css'],
    imports: [NavMenuComponent, Bind, Tabs, TabPanels, TabPanel]
})
export class UnitedInsuranceHomeComponent implements OnInit {

  constructor(private router: Router) { }
  insuranceRights: any;
  ngOnInit() {
    this.insuranceRights = JSON.parse(localStorage.getItem("InsuranceRights"));
  }
  routeToUnitedIssue() {
    this.router.navigateByUrl("united-travel-insurance");
  }
  routeToBooked(id: string) {
    this.router.navigate(['/search-booked-plan', id]);
  }
}
